module.exports = "https://www.gc-pro.gnp.com.mx/f99a6c902a6940d72ec6571abf6baa5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-16.jpg
// module id = 943
// module chunks = 0 1